import type { FC, PropsWithChildren } from 'react'
import AnnouncementAlert from './dashboard/AnnouncementAlert'
import Logo from './Logo'
import Orbs from './Orbs'
import { ProgressBarCss } from './toast/ToastWrapper'
import { Link } from 'react-router-dom'
import _kebabCase from 'lodash/kebabCase'

type LayoutProps = {
  title?: string
  loading?: boolean
  logoUrl?: string
  branding?: boolean
  announcement?: boolean
}

export const Layout: FC<PropsWithChildren<LayoutProps>> = ({
  title = '',
  children,
  loading = false,
  logoUrl,
  branding = false,
  announcement = false,
}) => {
  return (
    <div
      className="relative min-h-screen flex flex-col items-center justify-center"
      data-label={'layout-' + _kebabCase(title)}
    >
      <div className="mt-12">
        {logoUrl ? (
          <img
            src={logoUrl}
            className="h-12 mb-8 mx-auto max-w-[14rem]"
            alt="Logo"
          />
        ) : (
          <Logo className="mb-8 mx-auto scale-110" />
        )}

        <div className="p-8 rounded-lg w-[30rem] max-w-[90vw] mx-auto space-y-6 bg-[#0E0E0E]">
          <h1 className="text-2xl font-semibold text-center">
            {loading ? 'Loading...' : title}
          </h1>
          {loading && <ProgressBarCss duration={15000} />}
          {children}
        </div>
      </div>

      {branding && !loading && (
        <div className="text-gray-500 text-sm mt-4">
          <Link
            to="/signup"
            className="hover:text-gray-400"
          >
            Create a{' '}
            <img
              src="/favicon.ico"
              height={16}
              width={16}
              className="inline mb-1 pr-1"
              alt="favicon"
            />
            Rundown Studio account
          </Link>
        </div>
      )}

      {announcement && (
        <div className="max-w-(--breakpoint-lg) px-12">
          <AnnouncementAlert
            location="login"
            className="text-base mb-8 mt-12"
          />
        </div>
      )}

      <Orbs />
    </div>
  )
}
